"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIMEZONE = exports.Timezone = exports.TimezoneError = exports.DEFAULT_TIMEZONE_NAME = void 0;
const typegate_1 = require("typegate");
exports.DEFAULT_TIMEZONE_NAME = 'America/Toronto';
class TimezoneError extends Error {
    tag = 'TimezoneError';
}
exports.TimezoneError = TimezoneError;
class Timezone {
    // The private readonly __tag prevents callers for using the 'as' keyword to cast unvalidated timezone name.
    // Removing this property would be less safe.
    // @ts-ignore
    tag;
    name;
    constructor(name) {
        this.tag = 'Timezone';
        this.name = name;
    }
    static from(name) {
        try {
            Intl.DateTimeFormat(undefined, { timeZone: name });
            return (0, typegate_1.success)(new Timezone(name));
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        }
        catch (error) {
            return (0, typegate_1.failure)(new TimezoneError());
        }
    }
}
exports.Timezone = Timezone;
exports.DEFAULT_TIMEZONE = Timezone.from(exports.DEFAULT_TIMEZONE_NAME).unsafe();
